import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import { DialogTitle } from "../../components/common/dialog/DialogTitle";
import CardContent from "@material-ui/core/CardContent";
import { formatDateDDMMYYYYHHMM } from "../../utils/DateUtils";
import Style from "../../styles/js/StyleDashboard.js";

function msToTime(duration) {
  var milliseconds = parseInt((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return hours + ":" + minutes + ":" + seconds;
}

export default function StayExpanded({ open, setOpen, staySelected }) {
  const style = Style();

  console.log(staySelected);

  const handleClose = () => {
    setOpen(false);
  };

  return staySelected ? (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        className={style.dialog}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Visitas de {staySelected.dueno.nombre} {staySelected.dueno.apellido}
        </DialogTitle>
        <CardContent className={style.container}>
          <div className={style.section}>
            <Typography variant="h6" className={style.textExpanded}>
              Rangos de visitas
            </Typography>
            {staySelected.visitas.map((visit) => {
              return (
                <Typography variant="caption" className={style.textExpanded}>
                  {formatDateDDMMYYYYHHMM(visit.startTime)} -{" "}
                  {formatDateDDMMYYYYHHMM(visit.endTime)}
                </Typography>
              );
            })}
          </div>
          {staySelected.contactos.length !== 0 ? (
            <div className={style.section}>
              {" "}
              <Typography variant="h6" className={style.textExpanded}>
                Contactos
              </Typography>
              {staySelected.contactos.map((contact) => {
                return (
                  <div className={style.contact}>
                    <Typography variant="caption">
                      Nombre: {contact.usuario.nombre}{" "}
                      {contact.usuario.apellido}{" "}
                    </Typography>
                    <Typography variant="caption">
                      Teléfono: {contact.usuario.email}
                    </Typography>
                    <Typography variant="caption">
                      Tiempo de contacto: {msToTime(contact.solapamiento)}
                    </Typography>
                    <Typography variant="caption">
                      Visita:
                      {formatDateDDMMYYYYHHMM(contact.visita.startTime)} -{" "}
                      {formatDateDDMMYYYYHHMM(contact.visita.endTime)}
                    </Typography>
                  </div>
                );
              })}{" "}
            </div>
          ) : (
            <div className={style.noContact}>
              <Typography variant="caption">
                No registra contactos durante sus visitas
              </Typography>
            </div>
          )}
        </CardContent>
      </Dialog>
    </div>
  ) : null;
}
